import { Container } from "./styles";
import githubIcon from "../../assets/github-icon.svg"
import externalLinkIcon from "../../assets/external-link-icon.svg"
import ScrollAnimation from "react-animate-on-scroll";


export function Portfolio() {
  return (
    <Container id="portfolio">
      <h2>Portfolio</h2>

      <div className="projects">

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header className="title-and-icon">
              <h3 className="title">Sallamify</h3>
              <div className="project-links">
                <a href="https://sallamify.netlify.app/" target="_blank" rel="noreferrer">
                  <img src={externalLinkIcon} alt="Visitar site" />
                </a>
              </div>
            </header>
            <div className="body">
              <p>I created a copy of the Spotify web app using Next.js, Tailwind.CSS, and Spotify API. I tried to add all possible features by using available endpoints provided by Spotify API.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>React</li>
                <li>Typescript</li>
                <li>Next.js</li>
                <li>Tailwind.CSS</li>
                <li>Spotify API</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header className="title-and-icon">
              <h3 className="title">One Global</h3>
              <div className="project-links">
                <a href="https://ogstack.com" target="_blank" rel="noreferrer">
                  <img src={externalLinkIcon} alt="Visitar site" />
                </a>
              </div>
            </header>
            <div className="body">
              <p>I worked with OG as a full-stack developer. I worked on developing new microservices that allow non-technical users to buy and use some existing services without the need to work with anything related to the code or programming.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>React</li>
                <li>Typescript</li>
                <li>Node</li>
                <li>Nest.js</li>
                <li>React-bootstrap</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <div className="body">
              <h3>Rasilni</h3>
              <p>I worked as a full-stack developer with Infinite solution tech in Canada. I worked with a team on a social application that allows chatting and communicating between influencer and his fans. We added some features like reports, sending campaigns, and much more.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>Node</li>
                <li>Express</li>
                <li>MongoDB</li>
                <li>React</li>
                <li>Socket.io</li>
                <li>Twilio</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header className="title-and-icon">
              <h3 className="title">Y-hungry</h3>
              <div className="project-links">
                <a href="https://docs.google.com/document/d/1lGGIRDHTp_rUHkWLpAwd6WesepPs8ykoLbuZX95YgUg/edit?usp=sharing" target="_blank" rel="noreferrer">
                  <img src={externalLinkIcon} alt="Visitar site" />
                </a>
              </div>
            </header>
            <div className="body">
              <p>I worked as a full-stack developer with Yhangry startup in UK. Yhangry is a private chef startup, which started in the UK in May 2019. The mission of Yhangry was to allow people to spend quality time at home, with their friends & family. We accomplished this by making private chefs affordable and easy to book.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>Node</li>
                <li>Express</li>
                <li>React</li>
                <li>Socket.io</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header className="title-and-icon">
              <h3 className="title">Freelancer</h3>
              <div className="project-links">
                <a href="https://www.freelancer.com/u/sallam2018" target="_blank" rel="noreferrer">
                  <img src={externalLinkIcon} alt="Visitar site" />
                </a>
              </div>
            </header>
            <div className="body">
              <p>I worked as a freelancer on the Freelancer platform with a client in the UK on a built project that has some bugs to fix. The project was a platform to allow people to find jobs in UK after adding their information.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>Node.js</li>
                <li>MongoDB</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header className="title-and-icon">
              <h3 className="title">Humanity and Inclusion </h3>
              <div className="project-links">
                <a href="https://accessibility-audit-pwd.herokuapp.com/" target="_blank" rel="noreferrer">
                  <img src={externalLinkIcon} alt="Visitar site" />
                </a>
              </div>
            </header>
            <div className="body">
              <p>I worked with the Humanity and Inclusion organization in Gaza. They wanted a form filled out by their engineers. The form contains some questions related to buildings characteristic. The collected data is analysed and returned in a PDF file that contains a result that shows whether the building is suitable for people with disabilities or not.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>JavaScript</li>
                <li>CSS</li>
                <li>HTML5</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header className="title-and-icon">
              <h3 className="title">Esmée Fairbairn Foundation</h3>
              <div className="project-links">
                <a href="https://esmee-fairbairn-foundation.herokuapp.com/" target="_blank" rel="noreferrer">
                  <img src={externalLinkIcon} alt="Visitar site" />
                </a>
              </div>
            </header>
            <div className="body">
              <p>I worked with Esmée Fairbairn Foundation to build a simple form that allows them to filter the applications they receive from other organizations to get funds. The data is collected from the forms and saved for analysis in Salesforce.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>React</li>
                <li>Salesforce</li>
                <li>Material-UI</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header className="title-and-icon">
              <h3 className="title">Todo App</h3>
              <div className="project-links">
                <a href="https://todo-typescript-app.netlify.app/" target="_blank" rel="noreferrer">
                  <img src={externalLinkIcon} alt="Visitar site" />
                </a>
              </div>
            </header>
            <div className="body">
              <p>Simple draggable todo app using TypeScript
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>React.js</li>
<li>react-beautiful-dnd</li>
                <li>TypeScript</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>
      </div>
    </Container>
  );
}